module.exports = __webpack_public_path__ + "static/media/tiger-3424791_640-min.fde44415.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tiger-3424791_640-min.jpg
// module id = 137
// module chunks = 0